import * as React from 'react';
import { observer } from 'mobx-react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { SesAufstellflaechenTyp, ISesBeurteilungsErgebnis } from '../../../models/ApiTypesSes';
import Callout from '../../site/Callout';

interface ISesAuswertungFlaechenMesswertValidierungProps {
  beurteilungsErgebnis: ISesBeurteilungsErgebnis;
  aufstellflaechenTyp: SesAufstellflaechenTyp;
  vollstaendigAusgefuellt: boolean;
}

/** Zeigt eine Liste mit Hinweisen zur Beurteilung der Aufstellfläche des Scheinwerfer-Einstell-Prüfsystems an */
@observer
export default class SesAuswertungFlaechenMesswertValidierung extends React.Component<ISesAuswertungFlaechenMesswertValidierungProps, {}> {

  render() {
    const { beurteilungsErgebnis, aufstellflaechenTyp } = this.props;
    const beurteilungWirdAusgefuehrt = (beurteilungsErgebnis.beurteilung.length === 0);
    const hasErrors = beurteilungsErgebnis.beurteilung.some(beurteilung => !beurteilung.links.eingehalten || !beurteilung.rechts.eingehalten);

    let bsStyle: 'success' | 'danger' | 'warning' | 'info' | 'default';
    let header;

    if (!this.props.vollstaendigAusgefuellt) {
      header = <span>Es wurden noch nicht alle Messwerte eingetragen</span>;
      bsStyle = 'default';
    } else if (beurteilungWirdAusgefuehrt) {
      header = <span>Berechnung wird ausgeführt...</span>;
      bsStyle = 'info';
    } else if (hasErrors) {
      header = <span>Einige Werte liegen außerhalb des Toleranzbereichs</span>;
      bsStyle = 'danger';
    } else {
      header = <span>Alle Werte liegen innerhalb des Toleranzbereichs</span>;
      bsStyle = 'success';
    }

    return (
      <Callout bsStyle={bsStyle}>
        {header}
        {hasErrors && (
          <ListGroup className="error-list-group">
            {beurteilungsErgebnis.beurteilung.map((beurteilung, index) => (
              <span key={`LR${index}`}>
                {!beurteilung.links.eingehalten && (
                  <ListGroupItem header={beurteilung.links.label} className="error-list-item" href={`#${aufstellflaechenTyp}-${beurteilung.links.label}`}>
                    {beurteilung.links.bemerkung.map((text, bIndex) => <span key={`L${bIndex}`}>{text}</span>)}
                  </ListGroupItem>
                )}
                {!beurteilung.rechts.eingehalten && (
                  <ListGroupItem header={beurteilung.rechts.label} className="error-list-item" href={`#${aufstellflaechenTyp}-${beurteilung.rechts.label}`}>
                    {beurteilung.rechts.bemerkung.map((text, bIndex) => <span key={`R${bIndex}`}>{text}</span>)}
                  </ListGroupItem>
                )}
              </span>
            ))}
          </ListGroup>
        )}
      </Callout>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/ses/SesAuswertungFlaechenMesswertValidierung.tsx